import {Injectable} from '@angular/core';
import {CreateUserDto, UpdateUserDto, UserDto} from '@shared/dto';
import {AbstractUserService} from './abstract-user.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends AbstractUserService<UserDto, CreateUserDto, UpdateUserDto> {
}
